import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/shared/components/ui/card';
import { Spinner } from '@/shared/components/ui/spinner';

export const LoadingCard = ({ title }: { title: string }) => {
  return (
    <Card variant={'styled'} wrapWithStars>
      <CardHeader className="items-center space-y-14 pt-14">
        <CardTitle className="text-4xl font-medium">{title}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col items-center gap-8 pb-0 pt-6">
        <Spinner className="size-12" />
      </CardContent>
    </Card>
  );
};
